import constants from '@/constants/constants'
import { updatedDiff } from 'deep-object-diff'
import { watch } from '@vue/composition-api'

export default () => {
    return {
        created: ({localContext, parentContext}) => {
            watch(
                () => localContext.getters.getFieldsWithExistenceStatus,
                (n, o) => {
                    const difference = updatedDiff(n, o)


                    for (const fieldID of Object.keys(difference))
                        if (
                            difference[fieldID]
                            && 'exist' in difference[fieldID]
                            && difference[fieldID].exist === true
                        ) {
                            const fieldObj = parentContext.getters.getFormSourceJSON.fields[fieldID]

                            if (constants.FIELD_FROM_TYPE[fieldObj.field_type].WITH_SUBMISSION) {
                                parentContext.dispatch('submission/updateFormSubmissionField', {
                                    fieldID,
                                    updatedSubmission: constants.FIELD_FROM_TYPE[fieldObj.field_type].generateSubmissionObj(fieldObj)
                                })
                            }
                        }
                },
                {deep: true}
            )
        },
        getters: {
            getFieldsWithExistenceStatus: ({parentGetters}) => {
                const submissionDataObj = parentGetters['submission/getFormSubmission']

                const toReturn = parentGetters.getEnumeratedFieldsList.reduce((acc, {fieldId: fieldID}) => {
                    acc[fieldID] = {exist: true}
                    return acc
                }, {})

                parentGetters.getEnumeratedFieldsList.forEach(({fieldId: fieldID}, currentFieldIndex) => {
                    const submissionObj = submissionDataObj[fieldID] || {}
                    const fieldObj = parentGetters.getFormSourceJSON.fields[fieldID]

                    if (fieldObj?.condition) {
                        // Check if it's skip logic
                        if (fieldObj.condition._skip_logic_data) {
                            const skipLogicData = fieldObj.condition._skip_logic_data
                            
                            // Get selected options from submission - different field types use different properties
                            let selectedOptions = []
                            if (fieldObj.field_type === 'IMAGE_CHOICE') {
                                selectedOptions = submissionObj.selected_options || []
                            } else if (fieldObj.field_type === 'STAR_RATING') {
                                // StarRating uses a single numeric value, convert to array for consistency
                                selectedOptions = submissionObj.value !== null ? [submissionObj.value] : []
                            } else {
                                // Most selection fields use 'value' array
                                selectedOptions = submissionObj.value || []
                            }
                            
                            // Check if any selected option has a destination
                            for (const selectedIndex of selectedOptions) {
                                const destination = skipLogicData.destinations[selectedIndex]
                                if (destination) {
                                    // Handle different destination types
                                    if (destination.type === 'question' && destination.field_id) {
                                        // Jump to specific question
                                        toReturn[fieldID].jump_to = destination.field_id
                                    } else if (destination.type === 'end_survey') {
                                        // End survey
                                        toReturn[fieldID].jump_to = '__END_SURVEY__'
                                    } else if (destination.type === 'thank_you') {
                                        // Thank you page
                                        toReturn[fieldID].jump_to = '__THANK_YOU__'
                                    } else if (destination.type === 'redirect_url') {
                                        // Redirect URL
                                        toReturn[fieldID].jump_to = '__REDIRECT_URL__'
                                        toReturn[fieldID].redirect_url = destination.redirect_url
                                    }
                                    
                                    break
                                }
                            }
                        }
                        
                        // Check for traditional conditional logic (if not skip logic)
                        else if (fieldObj.condition.expression && fieldObj.condition.if_target) {
                            try {
                                const constants = require('@/constants/constants').default
                                const conditionalResult = constants.FIELD_FROM_TYPE[fieldObj.field_type].CONDITIONAL_LOGIC.VALIDATE(
                                    fieldObj.condition,
                                    submissionObj,
                                    fieldObj
                                )
                                
                                if (conditionalResult === true) {
                                    // Show target field
                                    toReturn[fieldObj.condition.if_target.field_id].exist = true
                                    
                                    // Hide fields between current and target
                                    const targetFieldIndex = parentGetters.getEnumeratedFieldsList.findIndex(
                                        ({fieldId}) => fieldId === fieldObj.condition.if_target.field_id
                                    )
                                    
                                    if (targetFieldIndex > -1 && targetFieldIndex > currentFieldIndex) {
                                        // Hide fields between current field and target field
                                        for (let i = currentFieldIndex + 1; i < targetFieldIndex; i++) {
                                            const fieldToHide = parentGetters.getEnumeratedFieldsList[i]
                                            if (fieldToHide) {
                                                toReturn[fieldToHide.fieldId].exist = false
                                            }
                                        }
                                    }
                                } else if (conditionalResult === false && fieldObj.condition.else_target) {
                                    // Show else target field
                                    toReturn[fieldObj.condition.else_target.field_id].exist = true
                                    
                                    // Hide fields between current and else target
                                    const targetFieldIndex = parentGetters.getEnumeratedFieldsList.findIndex(
                                        ({fieldId}) => fieldId === fieldObj.condition.else_target.field_id
                                    )
                                    
                                    if (targetFieldIndex > -1 && targetFieldIndex > currentFieldIndex) {
                                        // Hide fields between current field and target field
                                        for (let i = currentFieldIndex + 1; i < targetFieldIndex; i++) {
                                            const fieldToHide = parentGetters.getEnumeratedFieldsList[i]
                                            if (fieldToHide) {
                                                toReturn[fieldToHide.fieldId].exist = false
                                            }
                                        }
                                        
                                        // Always show the target field (even if it was hidden)
                                        toReturn[fieldObj.condition.else_target.field_id].exist = true
                                    }
                                }
                            } catch (error) {
                                console.warn('Error processing conditional logic for field', fieldID, error)
                            }
                        }
                    }
                })

                return toReturn
            },
            getExistingFields: ({getters, parentGetters}) => {
                const existingFields = Object.fromEntries(Object.entries(getters.getFieldsWithExistenceStatus).filter(([, {exist}]) => exist))

                let counter = 0

                parentGetters.getEnumeratedFieldsList.forEach(({fieldId}) => {
                    if (fieldId in existingFields) {
                        existingFields[fieldId].index = counter
                        counter++
                    }
                })

                return existingFields
            }
        }
    }
}